import React from 'react';
import { Button, Modal } from 'react-bootstrap';

const RemoveFromBatch = ({ show, handleClose, data }) => {
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Remove from Batch</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Remove {data?.length || 0} orders from batch (not implemented)</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RemoveFromBatch;